import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { UrineSampleAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-urine-sample-slot',
    templateUrl: './urine-sample-slot.component.html',
    styleUrl: './urine-sample-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UrineSampleSlotComponent implements SheetSlotComponentBase {

	@Input() action!: UrineSampleAction;
	value = null;

	constructor() {
	}
}
